import { ASSET_DIR } from '@/constants/farmerSolutions'

import Picture from '../picture'
import BannerHeader from './BannerHeader'
import VisitKisanAppButton from './VisitKisanAppButton'

const KisanAppFooterBanner = () => {
  return (
    <section className="md:px-6 max-w-7xl m-auto">
      <section className="relative p-6 md:px-[120px] md:py-5 md:-mt-[70px] md:rounded-2xl md:shadow-[0_4px_8px_rgba(0,0,0,0.12)] bg-secondary-one-10">
        <Picture
          className="absolute top-0 left-0 h-[140px] w-[120px] z-0 rotate-180"
          pictureStyle="hidden md:block"
          image={`${ASSET_DIR}/banner-ellipse-mobile`}
          hasPng
          imageAlt="Banner ellipse"
          role="presentation"
          aria-hidden
        />
        <Picture
          className="absolute top-0 right-0 h-[140px] w-[120px] z-0"
          pictureStyle="hidden md:block"
          image={`${ASSET_DIR}/banner-ellipse-mobile`}
          hasPng
          imageAlt="Banner ellipse"
          role="presentation"
          aria-hidden
        />
        <Picture
          className="absolute bottom-0 right-0 h-[108px] w-[140px] z-0"
          pictureStyle="md:hidden"
          image={`${ASSET_DIR}/banner-ellipse-mobile-footer`}
          hasPng
          imageAlt="Mobile Banner ellipse"
          role="presentation"
          aria-hidden
        />
        <article className="flex flex-col md:flex-row md:space-x-4 md:justify-between md:items-center">
          <div className="md:max-w-[555px] mb-6 md:mb-0">
            <BannerHeader />
          </div>
          <VisitKisanAppButton />
        </article>
      </section>
    </section>
  )
}

export default KisanAppFooterBanner
